var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.experiments['USER_V2'])?_c('UserV2'):_c('User')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }